export default "__VITE_ASSET__MJoshn7G__"